<script setup lang="ts">
import { useRouter } from 'vue-router'
import i18n from '@/plugins/i18n'
import { useAppStore } from '@/stores/app'

const router = useRouter()

const appStore = useAppStore()

const handleContinue = () => {
  const intendedRoute = appStore.leaveWarningModal.intendedRoute

  appStore.leaveWarningModal.confirmed = true

  if (intendedRoute) {
    router.push(intendedRoute)
  }
}
</script>

<template>
  <VDialog
    v-model="appStore.leaveWarningModal.active"
    width="auto"
    max-width="35rem"
  >
    <VCard>
      <VCardTitle>
        {{ appStore.leaveWarningModal.title }}
      </VCardTitle>
      <VCardText>
        {{ appStore.leaveWarningModal.text }}
      </VCardText>
      <VCardActions class="d-flex justify-space-between ma-2">
        <VBtn
          color="grey"
          variant="outlined"
          class="text-none"
          @click="appStore.resetLeaveWarningModal()"
        >
          {{ i18n.global.t('actions.cancel') }}
        </VBtn>
        <VBtn
          color="secondary"
          variant="flat"
          class="text-none"
          @click="handleContinue"
        >
          {{ i18n.global.t('actions.leave') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
